import { render, staticRenderFns } from "./recipients-table-filter.vue?vue&type=template&id=957ae0e8&"
import script from "./recipients-table-filter.vue?vue&type=script&lang=js&"
export * from "./recipients-table-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports